import clsx from "clsx";
import { isFunction } from "lodash";
import React, { ComponentProps, ReactNode } from "react";
import useResizeObserver from "use-resize-observer";
import { ErrorBoundary } from "../ErrorBoundary";
import { AccountBanner } from "@/components/Notifications/AccountBanner";

interface ColumnLayoutProps extends Pick<ComponentProps<"div">, "className"> {
    children: ReactNode;
}

export const ColumnLayout = ({ children, className }: ColumnLayoutProps) => {
    return (
        <div className={clsx("ui-column-layout flex h-screen max-h-screen flex-col", className)}>
            <AccountBanner />
            {children}
        </div>
    );
};

interface FillProps {
    children: ReactNode | ((height: number) => JSX.Element);
    allowOverflow?: boolean;
}

const Fill = ({ children, allowOverflow = false }: FillProps) => {
    const { ref, height } = useResizeObserver();

    return (
        <ErrorBoundary>
            <div
                ref={ref}
                className={clsx("ui-column-layout-fill flex-1", !allowOverflow && "overflow-y-auto")}
                id="columnLayoutFill"
            >
                {isFunction(children) ? (height ? children(height) : null) : children}
            </div>
        </ErrorBoundary>
    );
};

ColumnLayout.Fill = Fill;
